import { connect } from 'react-redux';
import { get } from 'lodash';
import View from './component';
import { setMessage } from './actions';

const mapStateToProps = (state) => ({
  message: get(state, 'alert.message'),
  maxWidth: get(state, 'alert.maxWidth'),
  buttonText: get(state, 'alert.buttonText', 'Close'),
});

const mapDispatchToProps = (dispatch) => ({
  close: () => dispatch(setMessage({ message: null, buttonText: 'Close' })),
});

export default connect(mapStateToProps, mapDispatchToProps)(View);
